import { render, staticRenderFns } from "./utube.vue?vue&type=template&id=2aaf2e27&scoped=true&"
import script from "./utube.vue?vue&type=script&lang=js&"
export * from "./utube.vue?vue&type=script&lang=js&"
import style0 from "./utube.vue?vue&type=style&index=0&id=2aaf2e27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf2e27",
  null
  
)

export default component.exports